import { FmdGoodOutlined } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';
import { useAdminUrlNavigation } from 'src/hooks/useAdminUrlNavigation';

import GroupsMap, {
  GROUPS_RESET_BOUNDS_EVENT,
} from '../../../map/components/GroupsMap';
import GroupsMapFullscreenModal from './GroupsMapFullscreenModal';
import MapWidget from './MapWidget';

const GroupsMapWidget = () => {
  const theme = useTheme();
  const { navigateToApplicationGroups } = useAdminUrlNavigation();

  return (
    <MapWidget
      title='Groups Map'
      subheader='Visualise geographic distribution of groups'
      avatar={
        <Box
          sx={{
            padding: `${theme.tokens.spacing.sm}px`,
            height: `${theme.tokens.spacing.sm * 5}px`,
            width: `${theme.tokens.spacing.sm * 5}px`,
            mx: `-${theme.tokens.spacing.sm}px`,
            borderRadius: theme.tokens.borderRadius.full,
            background: theme.tokens.colors.card,
            boxShadow: theme.tokens.shadows.sm,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.primary.main,
          }}
        >
          <FmdGoodOutlined />
        </Box>
      }
      mapContent={<GroupsMap />}
      renderFullscreen={(props) => <GroupsMapFullscreenModal {...props} />}
      onHeaderClick={() => navigateToApplicationGroups()}
      requireApplicationSelection={false}
      resetBoundsEventName={GROUPS_RESET_BOUNDS_EVENT}
    />
  );
};

export default GroupsMapWidget;
